import http from 'plugins/axios';

const BASE = '/ta/admin/tenant/msg/channel-source';

export default {
  page({ page, size, messageSource }) {
    let url = `${BASE}/page?page=${page}&size=${size}`;
    if (messageSource) {
      url += `&messageSource=${encodeURIComponent(messageSource)}`;
    }
    return http.get({ url });
  },
  messageSourceOptions() {
    return http.get({ url: `${BASE}/message-source-options` });
  },
  types() {
    return http.get({ url: '/ta/admin/tenant/msg/channel/types' });
  },
  enabledChannels(channelName) {
    let url = `${BASE}/enabled-channels`;
    if (channelName) {
      url += `?channelName=${encodeURIComponent(channelName)}`;
    }
    return http.get({ url });
  },
  detail(id) {
    return http.get({ url: `${BASE}/detail?id=${encodeURIComponent(id)}` });
  },
  save(data) {
    return http.post({ url: `${BASE}/save`, data });
  },
  update(data) {
    return http.post({ url: `${BASE}/update`, data });
  },
  remove(id) {
    return http.post({ url: `${BASE}/delete?id=${encodeURIComponent(id)}` });
  },
  setBindingEnabled(id, enabled) {
    return http.post({
      url: `${BASE}/enabled?id=${encodeURIComponent(id)}&enabled=${enabled}`,
    });
  },
  spotPlatformTemplateSuggest({ messageSource, notifyType, channelId, channelName }) {
    const q = [
      `messageSource=${encodeURIComponent(messageSource)}`,
      `notifyType=${encodeURIComponent(notifyType)}`,
    ];
    if (channelId != null && channelId !== '') {
      q.push(`channelId=${encodeURIComponent(channelId)}`);
    }
    if (channelName) {
      q.push(`channelName=${encodeURIComponent(channelName)}`);
    }
    return http.get({ url: `${BASE}/spot-platform-template-suggest?${q.join('&')}` });
  },
};
